define((require) => {
    "use strict";

    const PolymorphicCollection = require("shared/zbone/PolymorphicCollection");
    const EffectModel           = require("shared/ui/experience/action/effects/EffectModel");
    const EffectModels          = require("shared/ui/experience/action/effects/EffectModels");

    /**
     * A collection of <tt>EffectModel</tt>'s.
     *
     * @class EffectModelCollection
     */
    return PolymorphicCollection.extend("EffectModelCollection", {
        modelTypes: EffectModels,
        defaultModelType: EffectModel,

        hasTriggerType(triggerType) {
            return this.find((effect) => effect.get("triggerType") === triggerType) !== undefined;
        },

        removeByTriggerType(triggerType, options) {
            const models = this.where({triggerType});
            if (models.length) {
                this.remove(models, options);
            }
        },

        firstByTriggerType(triggerType) {
            return this.find((effect) => effect.get("triggerType") === triggerType);
        },

        classFromType(type) {
            return EffectModels.lookup(type);
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/effects/EffectModelCollection.js